import { z } from "zod";
import { apiGet } from "./client";

export const ProfileStatsSchema = z.object({
  years_researching: z.number().int().nonnegative(),
  publications: z.number().int().nonnegative(),
  students_supervised: z.number().int().nonnegative(),
});
export type ProfileStats = z.infer<typeof ProfileStatsSchema>;

export const ProfileSchema = z.object({
  name: z.string(),
  role: z.string(),
  tagline: z.string(),
  bio: z.array(z.string()),
  stats: ProfileStatsSchema,
});
export type Profile = z.infer<typeof ProfileSchema>;

export async function fetchProfile(): Promise<Profile> {
  return apiGet("/profile", ProfileSchema);
}
